import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import GeneralProposalDetailContMain from "presentation/view/container/GeneralProposal/GeneralProposalDetailContMain";

CommonEntrypoint(<GeneralProposalDetailContMain/>)